export const getFormattedDateRange = (value: any) => {
  if (!value) return '';

  const DATE_FORMAT = 'DD/MM/YYYY';
  const startDate = value.start.format(DATE_FORMAT);
  const endDate = value.end.format(DATE_FORMAT);
  return `${startDate} - ${endDate}`;
};
